import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  type UpdateShowRequest,
  type UpdateShowResponse,
  updateShow,
} from "@punchup/data/client/manager/shows";
import { SERIES_QUERY_KEY } from "./api";

interface UpdateShowParams {
  showId: string;
  venuePageId: string;
  tixologiEventId: number;
  date: string;
  startTime: string;
  endTime: string;
  eventSnapshot: {
    startTime: string; // ISO datetime (pre-update start_date)
    endTime: string; // ISO datetime (pre-update end_date)
  };
}

export function useUpdateShow(): UseMutationResult<
  UpdateShowResponse,
  Error,
  UpdateShowParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      showId,
      venuePageId,
      tixologiEventId,
      date,
      startTime,
      endTime,
      eventSnapshot,
    }: UpdateShowParams) =>
      updateShow({
        show_id: showId,
        venue_page_id: venuePageId,
        tixologi_event_id: tixologiEventId,
        date,
        start_time: startTime,
        end_time: endTime,
        event_snapshot: {
          event_id: tixologiEventId,
          start_time: eventSnapshot.startTime,
          end_time: eventSnapshot.endTime,
        },
      }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [SERIES_QUERY_KEY, variables.venuePageId],
      });
    },
  });
}
